<template>
  <div class="element-box-tp">
    <div v-if="showBackButton" class="d-flex justify-content-between pb-4">
      <span class="align-self-center">{{ t('parentBatchLabel', 'parentBatchLabel') }} {{ parent }}</span>
      <button @click="backToBatches" class="btn btn-secondary ">{{ t('backToBatchesButtonText','backToBatchesButtonText') }}</button>
    </div>
    <div class="sub-batch">
      <b-table :items="items" :fields="subFields" class="mb-0" :thead-tr-class="showBackButton ? '' : 'd-none'"  @row-hovered="hoverOn" @row-unhovered="hoverOff" :tbody-tr-class="rowClass" hover :busy.sync="busyTable" primary-key="id" striped hover responsive bordered>
        <template v-slot:head(id)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(reference)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(documents)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(quarantine)="data">
          <span>{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(type)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(status)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template v-slot:head(added_on)="data">
          <span >{{ t(data.label, data.label) }}</span>
        </template>
        <template class="busy-row" v-slot:table-busy>
          <vcl-table v-if="busyTable" :rows="1" :columns="subFields.length"></vcl-table>
        </template>
        <template v-slot:cell(id)="data">
          <span class="text-muted">{{ data.item.id }}</span>
        </template>
        <template v-slot:cell(reference)="data">
          <div :title="data.item.reference + ' (' + data.item.filesize + ' bytes)'">
            <span class="font-italic"> <b-badge pill variant="primary text-uppercase">{{t('subLabel', 'subLabel')}}</b-badge> {{ data.item.reference | trimBatchReference(batchRefTrim) }}</span>
            <span v-if="batchInfoAccessLevel <= userLevel" class="ml-2">
              <fontAwesomeIcon :icon="['fas', 'info-circle']" size="1x" :id="'info-' + data.item.id"
              @click="modalCreator({id: 'infoModal', title: t('batchInfoModalHead','batchInfoModalHead'), open: 'open'}, data.item, $event.target)"
              class="text-primary showhand align-middle" visibility="hidden"/>
            </span>
          </div>
        </template>
        <template v-slot:cell(documents)="data">
          <span>{{ data.item.total_docs }}</span>
        </template>
        <template v-slot:cell(quarantine)="data">
          <span v-if="data.item.total_failed > 0" class="text-danger">{{ data.item.total_failed }}</span>
          <span v-else >{{ data.item.total_failed }}</span>
        </template>
        <template v-slot:cell(type)="data">
          <span>{{ data.item.batch_type.name}}</span>
        </template>
        <template v-slot:cell(status)="data">
          <span v-if="statusSettings[data.item.status]">
            <b-badge v-if="statusSettings[data.item.status]" pill :class="statusSettings[data.item.status]['color']">{{t(statusSettings[data.item.status]['title'], statusSettings[data.item.status]['title'])}} </b-badge>
          </span>
          <span v-else> {{ data.item.status }} </span>
        </template>
        <template v-slot:cell(added_on)="data">
          <span >{{ data.item.added_on | clientDateFormat(datePickerFormat) }}</span>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-flex align-items-center">
            <div v-if="(data.item.total_docs > 0) && (data.item.status == 'proof')" class="mr-2">
              <div v-if="quarantineStatus">
                <div v-if="((data.item.total_generated + data.item.total_failed) == data.item.total_documents)">
                  <span v-if="(clientName === 'unis' || clientName === 'unistest') && !(Number(userLevel) >= 1.60)">
                  </span>
                  <span v-else>
                    <b-button @click="routeToViewProof(data.item.id, showTasksheets, clientName)" class="button btn btn-yellow text-white text-bold">
                        {{ t('viewProofButtonText','viewProofButtonText') }}
                    </b-button>
                  </span>
                </div>
              </div>
              <div v-else>
                <span v-if="(clientName === 'unis' || clientName === 'unistest') && !(Number(userLevel) >= 1.60)">
                </span>
                <span v-else>
                  <b-button @click="routeToViewProof(data.item.id, showTasksheets, clientName)" class="button btn btn-yellow text-white text-bold">
                      {{ t('viewProofButtonText','viewProofButtonText') }}
                  </b-button>
                </span>
              </div>
            </div>
            <div v-if="(data.item.total_docs > 0) && (data.item.status == 'approved')" class="mr-2">
              <span v-if="(clientName === ('unis' || 'unistest')) && !(Number(userLevel) >= 1.60)"></span>
              <span v-else>
                <button @click="routeToViewDocs(data.item.id, showTasksheets, clientName)" class="button btn btn-green text-white text-bold">
                  <span class="">{{ t('viewDocsButtonText','viewDocsButtonText') }}</span>
                </button>
              </span>
            </div>
            <template v-if="!(((data.item.status == 'approved') || (data.item.status == 'generating') || (data.item.status == 'uploaded')) && (Number(userLevel) < 3.00))">
              <b-dropdown id="action-dropdown-sub" :text="t('actionsButtonText', 'actionsButtonText')">
                <b-dropdown-item v-if="(data.item.total_docs > 0) && (data.item.status == 'proof') && batchInsertEnabled" @click="routeToInsert(data.item.id)" class="text-center optn optn-blue">
                  <span class="text-white">{{ t('insertButtonText','insertButtonText') }}</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="(data.item.total_docs > 0) && (data.item.status == 'rejected')" @click="routeToRejected(data.item.id, showTasksheets)" class="text-center optn optn-grey">
                  <span class="text-white">{{ t('viewRejectedButtonText','viewRejectedButtonText') }}</span>
                </b-dropdown-item>
                <span v-if="(userLevel == '3.00') && (data.item.proof_reminders > 0)">
                  <b-dropdown-item  @click="modalCreator({id: 'cancelRemindersModal', title: t('cancelRemindersModalHead','cancelRemindersModalHead'), open: 'open'}, data.item, $event.target)" class="text-center optn optn-purple">
                    <span class="text-white">{{ t('dontRemindButtonText','dontRemindButtonText') }}</span>
                  </b-dropdown-item>
                </span>
                <span v-if="(userLevel == '3.00')">
                  <b-dropdown-item @click="modalCreator({id: 'deleteModal', title: t('batchDeleteModalHead','batchDeleteModalHead'), open: 'open'}, data.item, $event.target)" class="text-center optn optn-red">
                    <span class="text-white">{{ t('deleteButtonText','deleteButtonText') }}</span>
                  </b-dropdown-item>
                </span>
              </b-dropdown>
            </template>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'SubBatch',
  props: [
      'busyTable',
      'showBackButton',
      'items',
      'parent'
  ],
  //this component inherits from the ManageBatches.vue component
  inject: [
    'statusSettings',
    //computed values
    'quarantineStatus',
    'userLevel',
    'clientName',
    'batchInfoAccessLevel',
    'batchInsertEnabled',
    'showTasksheets',
    'datePickerFormat',
    'batchRefTrim',
    //functions
    'hoverOn',
    'hoverOff',
    'backToBatches',
    //button routes
    'routeToViewProof',
    'routeToInsert',
    'routeToRejected',
    'routeToViewDocs',
    //modal functions
    'modalCreator'
  ],
  data () {
    return {
      subFields: [
        {key: 'id', label:'tableHeadBatchNumber', tdClass: 'standard-cell-width-sm', thClass: 'standard-th-width-sm'},
        {key: 'reference', label: 'tableHeadBatchReference', tdClass: 'standard-cell-width-xl cell-large', sortable: true, thClass: 'standard-th-width-xl showhand'},
        {key: 'documents', label: 'tableHeadDocuments', tdClass: 'standard-cell-width-sm', thClass: 'standard-th-width-sm'},
        {key: 'type', label: 'tableHeadType', sortable: true, tdClass: 'standard-cell-width-md', thClass: 'standard-th-width-md showhand'},
        {key: 'status', label: 'tableHeadStatus', sortable: true, tdClass: 'standard-cell-width-md', thClass: 'standard-th-width-md showhand'},
        {key: 'added_on', label: 'tableHeadAddedOn', sortable: false, tdClass: 'standard-cell-width-md', thClass: 'standard-th-width-md showhand'},
        {key: 'actions', label: '', sortable: false, tdClass: 'standard-cell-width-xl', thClass: 'standard-th-width-xl'}
      ]
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item) return
      if (item.highlighted && item.highlighted === 'yes') return 'table-success'
    }
  },
  created() {
    let quarantineStatus = this.$store.getters.getQuarantineStatus
    /*
    commented out because we don't use it yet
    if(quarantineStatus == true) {
        let quarantine = {key: 'quarantine', label: 'tableHeadQuarantined', tdClass: 'cell-small'}
        this.subFields.splice(3, 0, quarantine)
    }*/
  },
  filters:{
    trimBatchReference: function(reference, batchRefTrim) {
      if (reference && reference !== '') {
        return reference.slice(0, batchRefTrim)
      }
    },
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },
    clientDateFormat: function(date, datePickerFormat) {
      return moment(date).format(datePickerFormat + ' hh:mm:ss')
      //return moment(date).format(datePickerFormat)
    },
    clientDateFormat2: function(date, datePickerFormat) {
      // NS-10381 Change format for GSKP ( will require better solution later on )
      return moment(date).format(datePickerFormat + ' HH:mm:ss')
    }
  },
  components: {
    VclTable
  }
}
</script>

<style scoped>
.showhand{
  cursor: pointer;
}
/*-----Custom button and dropdown colours-----*/
.btn-yellow{
  background-color: #e67e22;
  border-color: #e67e22;
}
.btn-yellow:hover{
  background-color: #d35400;
  border-color: #d35400;
}
.btn-green{
  background-color: #1abc9c;
  border-color: #1abc9c;
}
.btn-green:hover{
  background-color: #16a085;
  border-color: #16a085;
}

#action-dropdown-sub >>> ul {
  padding: 0px !important;
  margin-top: 0px !important;
  background-color: white;
  /*
  border: 2px solid grey;
  border-radius: 5px;
  */
  border: 2px solid white;
  box-shadow: 0 0 1px rgba(15, 24, 33, 0.5),
  0 25px 65px rgba(15, 24, 33, 0.29);
}
#action-dropdown-sub >>> ul span .optn{
  border-top: 2px solid white;
  border-radius: 3px;
}
.optn-green{
  background-color: #1abc9c;
  border-color: #1abc9c;
}
.optn-green:hover{
  background-color: #16a085;
  border-color: #16a085;
}
#action-dropdown-sub >>> .optn-green .dropdown-item:hover{
  background-color: #16a085;
  border-color: #16a085;
  border-radius: 3px;
}
.optn-blue{
  background-color: #3498db;
  border-color: #3498db;
}
.optn-blue:hover{
  background-color: #2980b9;
  border-color: #2980b9;
}
#action-dropdown-sub >>> .optn-blue .dropdown-item:hover{
  background-color: #2980b9;
  border-color: #2980b9;
  border-radius: 3px;
}
.optn-purple{
  background-color: #9b59b6;
  border-color: #9b59b6;
}
.optn-purple:hover{
  background-color: #8e44ad;
  border-color: #8e44ad;
}
#action-dropdown-sub >>> .optn-purple .dropdown-item:hover{
  background-color: #8e44ad;
  border-color: #8e44ad;
  border-radius: 3px;
}
.optn-grey{
  background-color: #34495e;
  border-color: #34495e;
}
.optn-grey:hover{
  background-color: #2c3e50;
  border-color: #2c3e50;
}
#action-dropdown-sub >>> .optn-grey .dropdown-item:hover{
  background-color: #2c3e50;
  border-color: #2c3e50;
  border-radius: 3px;
}
.optn-red{
  background-color: #dc3545;
  border-color: #dc3545;
}
.optn-red:hover {
  background-color: #c82333;
  border-color: #c82333;
}
#action-dropdown-sub >>> .optn-red .dropdown-item:hover{
  background-color: #c82333;
  border-color: #c82333;
  border-radius: 3px;
}
</style>
